export default __webpack_public_path__ + "assets/92cbab1ce97c7481029f9b182c0dde06.png";